// extracted by mini-css-extract-plugin
module.exports = {"content":"e_2","pw-ad-scroll-container":"e_3","pw-in-article":"e_4"};